import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useFormCompletion } from '../Context/FormCompletionContext';
import { topbarLinks } from '../constants';

const OrderConfirmationTopBar = () => {
  const { pathname } = useLocation();
  const { completedForms } = useFormCompletion();

  return (
    <div className="flex items-center justify-center mb-6 mt-8">
      <div className="relative flex items-center">
        <div className="absolute top-5 left-14 right-14 xs:left-20 xs:right-20  md:left-32 md:right-32 h-[1px] bg-[#551E19]"></div>
        {topbarLinks.map((link, index) => {
          const isActive = pathname === link.route;
          const isDisabled = !completedForms[link.route.split("/").pop()];
          return (
            <div key={index} className="relative flex flex-col items-center z-10 mx-2 xxs:mx-4 xs:mx-8 sm:mx-10 md:mx-16">
              <NavLink
                to={isDisabled ? "#" : link.route}
                className={`flex flex-col items-center ${isDisabled && "pointer-events-none"}`}
              >
                <div
                  className={`h-10 w-10 flex flex-col items-center justify-center rounded-full border-2 font-normal text-xl z-10 ${
                    isActive
                      ? "bg-[#551e19] text-white border-[#551e19]"
                      : !isDisabled ? "bg-white text-[#551e19] border-[#551e19]" : "bg-white text-[#E6B17E] border-[#E6B17E]"
                  }`}
                >
                  {index + 1}
                </div>
                <p className="text-[10px] xxs:text-xs sm:text-sm mt-2 text-gray-600 text-nowrap">{link.label}</p>
              </NavLink>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default OrderConfirmationTopBar;